<div class="maincontainer" style="height: 100%">
    <div class="header" *ngIf="data?.fromwhere !== 'bestworks'">
      <h2 class="heading">Add Document</h2>
      <i
        (click)="closeModal()"
        style="cursor: pointer; margin-bottom: 4%"
        class="bi-x-lg"
      ></i>
    </div>
    <div class="header" *ngIf="data?.fromwhere == 'bestworks'">
      <h2 class="heading">Edit your best works</h2>
      <i
        (click)="closeModal()"
        style="cursor: pointer; margin-bottom: 4%"
        class="bi-x-lg"
      ></i>
    </div>
  
    <div
      class="bodycontainer2"
      style="height: calc(100% - 65px)"
      *ngIf="data?.fromwhere !== 'bestworks'"
    >
      <ng-container>
        <div class="subbodycontainer">
          <form #form="ngForm">
            <div style="padding: 10px 20px">
              <div class="section" style="width: 100%">
                <!-- ........................ -->
                <ng-container>
                  <div class="upload-details">
                    <label
                      for="uploaddoctitle"
                      class="required question"
                      style="
                        display: flex;
                        align-items: flex-start;
                        padding: 6px 0;
                        font-size: 15px;
                        min-width: 95px;
                      "
                      >Title<span
                        style="color: red; margin-left: 2px; font-size: 14px"
                        >*</span
                      >:</label
                    >
                    <div class="select" style="width: 100%">
                      <input
                        type="text"
                        id="uploaddoctitle"
                        name="uploaddoctitle"
                        #uploaddoctitle="ngModel"
                        [(ngModel)]="doctitle"
                        style="
                          height: 32px;
                          font-size: 15px;
                          background-color: #ffffff;
                          width: 100%;
                          margin-right: 5px;
                          border-radius: 5px;
                          outline: none;
                          color: #5d5d5d;
                          border: 1px solid #d4d4d4;
                          padding-left: 10px;
                        "
                        [required]="true"
                        pattern=".*\S+.*"
                        maxlength="30"
                      />
  
                      <div
                        *ngIf="uploaddoctitle.errors?.['required'] && (uploaddoctitle.touched || uploaddoctitle.dirty)"
                      >
                        <mat-error style="font-size: 13px">
                          Title is required.
                        </mat-error>
                      </div>
                      <div *ngIf="uploaddoctitle.errors?.['pattern']">
                        <mat-error style="font-size: 13px">
                          Title is required.
                        </mat-error>
                      </div>
                    </div>
                  </div>
  
                  <div class="upload-details">
                    <label
                      for="uploaddoctitle"
                      class="required question"
                      style="
                        display: flex;
                        align-items: flex-start;
                        padding: 6px 0;
                        font-size: 15px;
                        min-width: 95px;
                      "
                      >Description:</label
                    >
  
                    <textarea
                      class="captiontextarea"
                      name="caption"
                      #caption="ngModel"
                      [(ngModel)]="docdesc"
                    ></textarea>
                  </div>
                </ng-container>
                <div style="display: flex; padding: 20px 0px">
                  <label
                    for="uploaddoctype"
                    class="required question"
                    style="display: flex; align-items: center; min-width: 95px"
                    >Type:</label
                  >
  
                  <div class="select" style="width: 100%">
                    <mat-select
                      matNativeControl
                      required
                      name="uploaddoctype"
                      [(ngModel)]="filetypeselected"
                      id="doctype"
                      name="doctype"
                      #Doctype="ngModel"
                      [required]="true"
                      required
                      (selectionChange)="onSelectingfiletype($event)"
                      style="
                        background-color: #ffffff;
                        height: 33px;
                        width: -moz-available;
                        width: -webkit-fill-available;
                        color: #5d5d5d;
                        border: 1px solid #d4d4d4;
                        padding: 5px 10px;
                        font-size: 15px;
                        border-radius: 5px;
                        margin-right: 5px;
                      "
                    >
                      <mat-option value="PDF" style="color: #5d5d5d"
                        >PDF</mat-option
                      >
                      <mat-option value="image/*" style="color: #5d5d5d"
                        >Image</mat-option
                      >
                    </mat-select>
                    <div
                      *ngIf="Doctype.errors?.['required'] && (Doctype.touched || Doctype.dirty)"
                    >
                      <mat-error style="font-size: 13px">
                        File type is required.
                      </mat-error>
                    </div>
                  </div>
                </div>
  
                <div class="upload-details">
                  <label
                    for="uploaddoctitle"
                    class="required question"
                    style="
                      display: flex;
                      align-items: flex-start;
                      padding: 6px 0;
                      font-size: 15px;
                      min-width: 95px;
                    "
                    >Upload File<span
                      style="color: red; margin-left: 2px; font-size: 14px"
                      >*</span
                    >:</label
                  >
                  <div class="select" style="width: 100%">
                    <input
                      type="file"
                      #fileInput
                      name="fileInput"
                      id="fileInput"
                      [accept]="filetype"
                      (change)="fileBrowseHandler($event.target)"
                      style="border: none"
                      [required]="true"
                    />
  
                    <div
                      *ngIf="isfileuploaderror"
                      style="color: red; font-size: 12px"
                    >
                      File is required.
                    </div>
                  </div>
                </div>
              </div>
  
              <div class="document" *ngFor="let file of files; let i = index">
                <div class="imganddetails">
                  <div class="filethumbnail">
                    <div *ngIf="!isloadingcomplete" class="loadercontainer">
                      <span class="loader"></span>
                    </div>
                    <img
                      *ngIf="file?.type == 'application/pdf'"
                      class="uplodadedimg"
                      src="./../../../assets/icons/pdfplaceholder.png"
                    />
                    <img
                      *ngIf="file?.type !== 'application/pdf'"
                      class="uplodadedimg"
                      style="object-fit: cover"
                      [src]="file.url"
                    />
                  </div>
                  <div class="filedetails">
                    <p class="documenttitle">{{ file?.name }}</p>
                    <p
                      class="documentdetails"
                      *ngIf="file?.type == 'application/pdf'"
                    >
                      PDF
                    </p>
                    <p class="documentdetails" *ngIf="filetype == 'image/*'">
                      Image
                    </p>
                  </div>
                </div>
                <button
                  class="removedocumentbutton"
                  (click)="deleteEntry($event, i)"
                >
                  <i class="bi-x-lg"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
  
        <div class="footer">
          <button mat-dialog-close class="cancelbtn">Cancel</button>
          <button class="savebtn" (click)="saveToServer(form)">Save</button>
        </div>
      </ng-container>
    </div>
  
    <form #form="ngForm">
      <div class="bodycontainer1" *ngIf="data.fromwhere == 'bestworks'">
        <ng-container>
          <div
            class="upload-details"
            style="align-items: flex-start; margin: 0; margin-bottom: 15px"
          >
            <label
              for="uploaddocphoto"
              class="required question"
              style="display: flex; align-items: center; padding: 3px 0"
              >Upload File:</label
            >
            <div class="select">
              <input
                type="file"
                #fileInput
                name="fileInput"
                id="fileInput"
                [accept]="filetype"
                [multiple]="allowmultiple"
                (change)="fileBrowseHandler($event.target)"
                style="border: none"
                [required]="true"
              />
              <div *ngIf="isfileuploaderror" style="color: red; font-size: 13px">
                File is required.
              </div>
              <div *ngIf="maxlimit" style="color: red; font-size: 13px">
                Maximum of 10 photos allowed
              </div>
            </div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              gap: 20px;
              max-height: 400px;
            "
          >
            <div
              *ngIf="!isloadingcomplete"
              class="loadercontainer"
              style="width: 97%; height: 73%"
            >
              <span class="loader"></span>
            </div>
            <div
              class="bestworksimagecontainer"
              *ngFor="let file of filelinkarray; let i = index"
            >
              <div class="imganddetails" style="width: 60%">
                <div class="filethumbnail">
                  <img [src]="file" class="bestworkimage" alt="uplodadedimg" />
                </div>
                <div class="filedetails" style="width: 100%">
                  <p class="documenttitle">{{ geturldata(file) }}</p>
                  <p class="documentdetails">Image</p>
                </div>
              </div>
  
              <button
                class="removedocumentbutton"
                (click)="removeBestworkImage(file, i)"
              >
                <i
                  style="height: 20px; width: 20px; font-size: 20px; color: grey"
                  class="fas fa-times"
                ></i>
              </button>
            </div>
          </div>
        </ng-container>
      </div>
  
      <div class="footer" *ngIf="data.fromwhere == 'bestworks'">
        <button mat-dialog-close class="cancelbtn">Cancel</button>
        <button class="savebtn" (click)="saveToServer(form)">Save</button>
      </div>
    </form>
  </div>
  